
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/valentine",
      function () {
        return require("private-next-pages/valentine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/valentine"])
      });
    }
  